// extracted by mini-css-extract-plugin
export default {"countContainer":"DropdownIndicator_countContainer__JbE8Z","countText":"DropdownIndicator_countText__Fxrv2"};